import React, { useState, useEffect, useRef } from "react";
import TextField from "@mui/material/TextField";
import { Button, IconButton } from "@mui/material";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../Assets/Styles/Style.css";
import { getAPI } from "../../Global";
import DescriptionInvestment from "./DescriptionInvestment";
import Transaction from "../../components/descriptionshow/Transaction";
import DynamicAutocomplete from "../../utils/DynamicForm/DynamicAutocomplete";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import PrintComponent from "./PrintComponent";
import useApi from "../../utils/useApi";
import CustomTextField from "../../utils/CustomTextField";
const FlashTransaction = ({ isOpen = false }) => {
  const [value, setValue] = useState("");
  const [data, setData] = useState(null);
  const [invId, setInvId] = useState(null);
  const [invNo, setInvNo] = useState(null);
  const [groupName, setGroupName] = useState("");
  const [subscriptionNumber, setSubscriptionNumber] = useState("");
  const [amount, setAmount] = useState(0);
  const [selectedMonth, setSelectedMonth] = useState(1);
  const [totalMonths, setTotalMonths] = useState(0);
  const [passedMonth, setPassedMonth] = useState(0);
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [recordTotal, setRecordTotal] = useState(0);
  const firstInputRef = useRef(null);
  const secondInputRef = useRef(null);
  const submitButtonRef = useRef(null);
  const [recording, setRecording] = useState(false);
  const [printData, setPrintData] = useState(null);
  const [user, setUser] = useState();
  const [disableTrxn, setDisableTrxn] = useState(false);
  const [isInvestmentDisabled, setIsInvestmentDisabled] = useState(false);
  const [investmentId, setInvestmentId] = useState(null);
  const { Get, Post, Patch } = useApi();

  useEffect(() => {
    if (isOpen) {
      requestAnimationFrame(() => firstInputRef.current?.focus());
    }
  }, [isOpen]);
  const makeRequestOnLooseFocus = async () => {
    if (groupName && subscriptionNumber) {
      const inputValue = `${groupName}-${subscriptionNumber}`;
      await getDataUsingInvNo(inputValue);
    }
  };
  const toggleRecording = () => {
    setRecording((prev) => !prev);
    setRecordTotal(0);
  };
  const getDataUsingInvNo = async (invNo) => {
    try {
      setDisableSubmit(false);
      const getInvestmentDetails = await Get(
        `${getAPI("getTransactionsByInvestmentNo")}${invNo}/`
      ).catch((resp)=>{
        setDisableTrxn(true);
        toast.warning(resp.response.data.error);
      });
      const investmentId = getInvestmentDetails.investment_info.id;
      setInvestmentId(investmentId);
      setIsInvestmentDisabled(getInvestmentDetails.investment_info.is_disabled);
      const nextDueResponse = await Get(
        `${getAPI("getInvestmentNextDue")}${investmentId}/`
      ).catch((resp)=>{
        setDisableTrxn(true);
        toast.warning(resp.response.data.error);
        return null;
      });
      let dueMonths = 0;
      if(nextDueResponse !== null){
         dueMonths = nextDueResponse.investment_info.due_payment_months;
        setSelectedMonth((dueMonths == 0)?1:dueMonths)
        const combinedData = {
          ...getInvestmentDetails,
          due_summary: nextDueResponse.due_summary,
          investment_info: nextDueResponse.investment_info,
        };
        setData(combinedData);
        setInvNo(combinedData.investment_info.investment_id);
        setInvId(investmentId);
        setTotalMonths(combinedData.investment_info.total_month);
        setPassedMonth(combinedData.investment_info.total_passed_months);
        if (combinedData.due_summary && combinedData.due_summary.payable_amt) {
          setAmount(combinedData.due_summary.payable_amt);
        }
        setUser(combinedData.user_info.full_name);
      }else{
        setDisableSubmit(true);
        setDisableTrxn(true);
        setData(getInvestmentDetails);
      }
      
     
    } catch (error) {
      toast.error(`No Investment found with number ${invNo} ${error}`);
      setValue("");
      setData(null);
      setAmount(0);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!subscriptionNumber) {
      toast.error("Subscription Number required");
      return;
    }
    const frmdata = new FormData(e.target);
    const formData = Object.fromEntries(frmdata.entries());
    
    const description = `Paid Via Cash ${subscriptionNumber} of ${groupName}`;
    formData.description = description;
    formData.investment = invId;
    formData.transaction_at = new Date();
    formData.is_cash = true;
    if (formData.selectedMonth > totalMonths - passedMonth) {
      toast.error(`Maximum allow month are ${totalMonths - passedMonth}`);
      return;
    }
    if (invId) {
      try {
        const response = await Post(getAPI("transaction"), formData);
        const {
          voucher,
          group_title,
          subscription_no,
          user_full_name,
          amount,
        } = response.data;
        setPrintData({
          ...formData,
          group_title,
          subscription_no,
          user_full_name,
          amount,
          voucher,
        });
        toast.success("Transaction successful");
        setSubscriptionNumber("");
        setData(null);
        setInvId(null);
        setInvNo(null);
        firstInputRef.current.focus();
        if (recording) {
          let total = recordTotal + parseInt(formData.amount);
          setRecordTotal(total);
        }
      } catch (error) {
        toast.error(error.response.data.error.replace(/\[|\]|'/g, ""));
      }
    } else {
      toast.error("Investment Id not found");
    }
  };
  const handleKeyPress = (event, nextRef) => {
    if (event.key === "Enter") {
      makeRequestOnLooseFocus();
      event.preventDefault();
      nextRef.current.focus();
    }
  };
  const changeInvestmentStatus = async (invId, status)=>{
    await Patch("investment", invId, {"is_disabled":status});
  }
  const getAmountByMonth = async (month) => {
    try {
      const getInvestmentDetails = await Get(
        `${getAPI("getTransactionsByInvestmentNo")}${invNo}/`
      );
      const response = await Get(
        `${getAPI("getInvestmentNextDue")}${invId}/?month=${month}`
      );
      const combinedData = {
        ...getInvestmentDetails,
        due_summary: response.due_summary,
        investment_info: response.investment_info,
      };

      
      
      setData(combinedData);
      // console.log(combinedData);
      setTotalMonths(combinedData.investment_info.total_month);
      setPassedMonth(combinedData.investment_info.total_passed_months);
      if (combinedData.due_summary && combinedData.due_summary.payable_amt) {
        setAmount(combinedData.due_summary.payable_amt);
      }
    } catch (error) {
      toast.error(`Failed to fetch amount for month ${month}`);
    }
  };
  const handleMonthChange = (newMonth) => {
    if (newMonth == 0) {
      makeRequestOnLooseFocus();
    }
    if (newMonth >= 1 && newMonth <= totalMonths - passedMonth) {
      setSelectedMonth(newMonth);
      getAmountByMonth(newMonth);
    }
  };
  const Styles = {
    margin: "10px",
    width: "30%",
  };
  const inputStyles = {
    fontSize: "25px",
    fontWeight: "bold",
  };
  const counterStyle = {
    margin: "5px",
    padding: "5px",
    border: "2px solid #bfbfbf",
  };
  return (
    <div className="row">
      <Button onClick={toggleRecording}>
        {recording ? (
          <img src="assets/img/stop.png" height="35px" />
        ) : (
          <img src="assets/img/start.png" height="35px" />
        )}
      </Button>
      {recording ? <h2>{recordTotal}</h2> : ""}
      <div
        className="col-md-12"
        style={{ width: "100vw", marginBottom: "10px" }}
      ></div>
      <div className="col-md-8">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div
              className="col-md-8"
              style={{ borderRight: "5px solid #bfbfbf" }}
            >
              <div className="row">
                <CustomTextField
                  label="Group Name"
                  type="text"
                  value={groupName}
                  style={Styles}
                  onChange={(e) => setGroupName(e.target.value.toUpperCase())}
                  onBlur={makeRequestOnLooseFocus}
                  variant="standard"
                  inputRef={firstInputRef}
                  onKeyDown={(e) => handleKeyPress(e, secondInputRef)}
                  InputProps={{
                    style: inputStyles,
                  }}
                />
                <CustomTextField
                  label="Subscription Number"
                  type="text"
                  value={subscriptionNumber}
                  onBlur={makeRequestOnLooseFocus}
                  onChange={(e) => setSubscriptionNumber(e.target.value)}
                  variant="standard"
                  style={Styles}
                  inputRef={secondInputRef}
                  onKeyDown={(event) => handleKeyPress(event, submitButtonRef)}
                  InputProps={{
                    style: inputStyles,
                  }}
                />
                {(data !== null && data.due_summary !== undefined)?<Button
                  type="submit"
                  variant="contained"
                  style={{
                    padding: "0px",
                    height: "30px",
                    marginTop: "20px",
                    width: "100px",
                  }}
                  disabled={disableSubmit}
                  ref={submitButtonRef}
                >
                  Save
                </Button> :""}
                
              </div>
            </div>
            {data && (
              <div className="col-md-4">
                <span
                  style={{
                    // textAlign: "center",
                    fontSize: "20px",
                    fontFamily: "Comfortaa",
                    position: "absolute",
                    left: "5px",
                    fontWeight: "bold",
                  }}
                >
                  {data.user_info.full_name}
                  <br />
                  <strong
                    style={{
                      textAlign: "center",
                      fontSize: "20px",
                      fontFamily: "Comfortaa",
                      position: "absolute",
                      left: "5px",
                      fontWeight: "bold",
                    }}
                  >
                    {data.investment_info.user_phone}
                  </strong>
                </span>
              </div>
            )}
          </div>
          {
            (data !== null && data.due_summary !== undefined)?  <div className="row">
            <div className="col-md-3" style={{ marginTop: "12px" }}>
              <DynamicAutocomplete
                fields={[
                  {
                    apiUrl: getAPI("account"),
                    displayKey: "name",
                    valueKey: "id",
                    name: "account",
                    label: "Account",
                    variant: "standard",
                    advance: true,
                    defaultObj: {
                      id: 2,
                      name: "Cash",
                      description: "Cash",
                    },
                  },
                ]}
              />
            </div>
            {data ? (
              <div
                style={{
                  marginTop: "10px",
                  fontSize: "12px",
                  color: "#8A8787",
                }}
              >
                {disableSubmit ? (
                  <span style={{ color: "red" }}>
                    Max {totalMonths - passedMonth} months allowed!
                  </span>
                ) : (
                  "Month"
                )}
                <div
                  className="col-md-3"
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <IconButton
                    onClick={() => handleMonthChange(selectedMonth - 1)}
                    disabled={selectedMonth <= 1}
                    style={counterStyle}
                  >
                    <RemoveIcon />
                  </IconButton>
                  <input
                    name="selectedMonth"
                    style={{
                      border: "2px solid #bfbfbf",
                      borderRadius: "20px",
                      width: "50px",
                      paddingLeft: "18px",
                    }}
                    maxLength={totalMonths - passedMonth}
                    onChange={(e) => {
                      const value = parseInt(e.target.value);
                      if (value > totalMonths - passedMonth) {
                        setDisableSubmit(true);
                      } else {
                        setDisableSubmit(false);
                      }
                      setSelectedMonth(value);
                    }}
                    onBlur={() => handleMonthChange(selectedMonth)}
                    value={selectedMonth}
                    type="number"
                    variant="standard"
                    label="Month"
                  />
                  <IconButton
                    onClick={() => handleMonthChange(selectedMonth + 1)}
                    disabled={selectedMonth >= totalMonths - passedMonth}
                    style={counterStyle}
                  >
                    <AddIcon />
                  </IconButton>
                </div>
              </div>
            ) : (
              ""
            )}
            <TextField
              label="Amount"
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              variant="standard"
              name="amount"
              style={{ margin: "10px", width: "20%" }}
              InputProps={{
                style: inputStyles,
              }}
            />
            <div className="col-md-3">
              <input
                hidden
                name="transaction_type"
                value="subscription_amt"
                type="text"
              />
            </div>
          </div>:""
          }
         
        </form>
        <hr />
        {(data !== null && data.due_summary !== undefined)? <DescriptionInvestment data={data} />:""}
      </div>
      <div className="col-md-4">
        {data && <Transaction data={data} height={"400px"} />}
      </div>
      <div className="col-md-12">
      {(isInvestmentDisabled)?<Button style={{backgroundColor: 'green', color: 'white'}} onClick={()=>{changeInvestmentStatus(investmentId, false)}}>Enable Current Investment</Button>:<Button style={{backgroundColor: 'red', color: 'white'}} onClick={()=>{changeInvestmentStatus(investmentId, true)}}>Disable Current Investment</Button>}
        
      </div>
      {printData && <PrintComponent formData={printData} />}
    </div>
  );
};
export default FlashTransaction;
